import FormInputNumber from './form-input-number';

export { FormInputNumber };
export default FormInputNumber;
